import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--mc-navy-950)] hex-grid px-5" data-testid="page-404">
      <SEO
        title="Page introuvable"
        description="La page demandée est introuvable sur MetaConnect."
        canonical="/404"
        noIndex
      />
      <div className="text-center max-w-md">
        <div className="font-display text-[#0284C7] text-[12px] uppercase tracking-[0.22em]">Erreur 404</div>
        <h1 className="mt-3 font-display text-white text-4xl">Page introuvable</h1>
        <p className="mt-4 text-[var(--mc-muted)]">
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <Link to="/" className="mt-7 inline-flex btn-primary px-6 py-3 rounded-full text-[14px] font-medium">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
